import { useSelector, useDispatch } from 'react-redux';
import { getRequests } from '../actions/requests';
import { dateToString, toTitleCase } from '../utils/functions';
import { listSelector } from '../selectors';
import { requestsIndexName } from '../utils/variables';
// import { loadRequestsCount } from '../utils/variables';

const useRequestData = ({ infiniteScroll = false } = {}) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const customerId = user?.customer?.id || '';
  const defaultOptions = useSelector(state =>
    listSelector.listOptions({ state, name: requestsIndexName, infiniteScroll }),
  );
  const allRows = useSelector(state => state.requests.allRows);

  return ({ nextStartIndex, nextItemCount, nextScrollCount }) => {
    // const limit = count; // stopIndex - startIndex;
    // const offset = startIndex;
    const body = {
      id: customerId,
      limit: defaultOptions?.itemCount,
      offset: defaultOptions?.startIndex,
      fromDate: dateToString(defaultOptions?.startDate),
      toDate: dateToString(defaultOptions?.endDate),
      lob: toTitleCase(defaultOptions?.lob.toString()), // defaultOptions?.lob,
      nextItemCount,
      nextScrollCount,
      nextStartIndex,
    };

    // cellMeasurerCache.clearAll();
    // listRef.current.recomputeRowHeights();
    // listRef.current.forceUpdate();

    // if (allRows && allRows.length > 0 && startIndex > 0) {
    //   return dispatch(getRequests.getNextRequestsAction(body));
    // }
    if (allRows && allRows.length > 0 && infiniteScroll) {
      return dispatch(getRequests.getNextRequestsAction(body));
    }
    if (!allRows || allRows.length === 0) {
      return dispatch(getRequests.getRequestsAction(body)).catch(err => {
        // console.log('err: ', err);
      });
    }
    return () => {};
  };
};
export default useRequestData;
